module.exports = __webpack_public_path__ + "static/media/KG.73d23380.png";